import axios from 'axios'

// const url = `http://localhost:4000`
const url = `https://api.careerroshi.com`
// const url = process.env.REACT_APP_BASE_URL || `http://localhost:4000`

export const AddBulkUser = async (body) => {
    let result = await axios.post(`${url}/org/bulk/user/create-user`, body)
    return result
}

export const AddUser = async (body) => {
    let result = await axios.post(`${url}/org/user/create-user`, body)
    return result
}

export const FetchUsersList = async (page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${url}/alluserlist`, { params: { page, limit, search, sort, filter } })
    return result
}
export const FetchCoacheList = async (search, id) => {
    let result = await axios.get(`${url}/organization/user/fetchCoatches`, { params: { search, orgId: id } })
    return result
}

export const UpdateType = async (id, type) => {
    let res = await axios.put(`${url}/admin/user/update/${id}`, {type})
    return res.data
}


export const FetchOrganizationList = async (search) => {
    let result = await axios.get(`${url}/organizations/fetch-organiztion-list`, { params: { search } })
    return result
}

export const FetchCoachSearchList = async (search, orgId= '') => {
    let result = await axios.get(`${url}/searchCoach`, { params: { search, organisation: orgId } })
    return result.data
}

export const FetchJobSeekerCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerCoach/${id}`)
    return result.data
}

export const FetchJobSeekerByCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerlist-by-coach/${id}`)
    return result.data
}

export const FetchDbStats = async () => {
    let result = await axios.get(`${url}/stats`)
    return result.data
}

export const AssignNewCoach = async (body) => {
    let result = await axios.post(`${url}/assignCoach/`, body)
    return result.data
}

export const FetchClient = async (id) => {
    let result = await axios.get(`${url}/user/${id}`)
    return result.data
}

export const UpdateUserAction = async (id, body) => {

    let res = await axios.put(`${url}/update-user/${id}`, body)
    return res.data

}

export const SendUserNewPasswordAction = async (id, body) => {

    let res = await axios.put(`${url}/user/send-new-password/${id}`, body)
    return res.data
}

export const CreateCheckoutSession = async (data) => {
    let body = {
        name: "Coach Licence",
        price: data.pendingAmount || 45,
        userId: data.id
    }
    let res = await axios.post(`${url}/org/coach/payment/session`, body)
    return res.data;
}

export const BlockunblockUser = async (id) => {
    let res = await axios.post(`${url}/user/blockUnBlock/${id}`);
    return res.data
}

export const UploadOrgLogo = async (orgId, file) => {
    const formData = new FormData();
    formData.append('logo', file);
    let res = await axios.put(`${url}/organizations/upload-logo/${orgId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data;
}